<template lang="pug">
Toast.av-toast-invisible(
  v-if="includeToast"
  :content="decodeHtml(toastContent)"
  :class="{'av-toast-animate-visible': showToast && countData}"
  emoji="🎉 "
  :timeout-to-dismiss="12_000"
)
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Toast } from "@anyvan-ui/toast";
import { mapGetters } from "vuex";
import * as he from 'he'
import { GET_BOOKINGS_COPY } from "~/store/booking-insights";
import { GET_PICKUP_CITY } from "~/store/listing";

export default defineComponent({
  name: "BookingCountToast",
  components: {
    Toast,
  },

  data() {
    return {
      includeToast: false,
      showToast: false
    }
  },

  computed: {
    ...mapGetters("booking-insights", {
      countData: GET_BOOKINGS_COPY as AvBookingsCopy | null
    }),
    ...mapGetters("listing", {
      pickupCity: GET_PICKUP_CITY
    }),
    toastContent(): string {
      if (!this.countData) return ''

      let location = this.countData.location
      // Use getPickupCity when:
      // - Booking Insights location is empty
      // - Booking Insights location is 'London', which possibly a fallback value
      if (!this.countData.location || (this.countData.location == 'London' && this.pickupCity)) {
        location = this.pickupCity
      }

      const translationParams = {
        count: this.countData.total_bookings || 0,
        location,
        timePeriod: this.getTimePeriodLabel(this.countData.timePeriod)
      }
      return this.$t('location_form.booking_count_message', translationParams)
    }
  },

  watch: {
    countData: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          this.includeToast = false
          this.showToast = false
          this.$nextTick(() => {
            this.includeToast = true
            setTimeout(() => { this.showToast = true }, 100)
          })
        }
      }
    }
  },

  mounted() {
    this.includeToast = true
    setTimeout(() => { this.showToast = true }, 100)
  },

  methods: {
    decodeHtml(str: string) {
      return he.decode(str)
    },
    getTimePeriodLabel(timePeriod: string | undefined): string {
      return timePeriod
        ? this.$t('time_period.' + timePeriod.toLowerCase())
        : this.$t('time_period.year')
    }
  }
})
</script>

<style lang="css">
@import '@anyvan-ui/toast/vanilla.css';
</style>
